// ie polyfill
import '@babel/polyfill'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import { VueAxios } from './utils/request'

import bootstrap from './core/bootstrap'
import './core/use'
import './permission' // permission control
import './utils/filter' // global filter

Vue.config.productionTip = false

// mount axios Vue.$http and this.$http
Vue.use(VueAxios)

new Vue({
  router,
  store,
  created () {
    bootstrap()
  },
  render: h => h(App)
}).$mount('#app')

Vue.prototype.refreshPagination = function (page, pagination) {
  if (page) {
    pagination.current = page.current
    pagination.pageSize = page.size
    pagination.total = page.total
  }
  return pagination
}

Vue.prototype.treeUtils = {
  getParent: function (key, tree) {
    let parent = null
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i]
      if (node.children) {
        if (node.children.some(item => item.key === key)) {
          parent = node
        } else if (this.getParent(key, node.children)) {
          parent = this.getParent(key, node.children)
        }
      }
    }
    return parent
  },

  title2Key: function (node, addValue) {
    if (node != null) {
      if (addValue && addValue === true) {
        node.value = node.title
      }
      node.key = node.title
      if (!node.leaf) {
        for (let i = 0; i < node.children.length; i++) {
          this.title2Key(node.children[i], addValue)
        }
      }
    }
  },

  treeNodeToArray: function (node, arr, scopedSlots, addValue) {
    if (node != null) {
      if (scopedSlots && scopedSlots instanceof Object) {
        node.scopedSlots = scopedSlots
      }
      if (addValue && addValue === true) {
        node.value = '' + node.key
      }
      arr.push(node)
      if (!node.leaf) {
        for (let i = 0; i < node.children.length; i++) {
          this.treeNodeToArray(node.children[i], arr, scopedSlots, addValue)
        }
      }
    }
    return arr
  }
}